<template>
<div>

    <div class="container-fluid">
        <div class="row">

            <div class="col-lg-12">
                <div class="card box-margin">
                    <div class="card-header">
                        <i class="fas fa-car-side"></i><span> Modelo del Vehiculo</span>
                        <div class="btn-group" role="group">
                            <template v-if="AsignarRolPermisosByUsuario.includes('modelo.crear')">
                                <button type="button" class="btn btn-success" @click="abrirModal"><i class="fas fa-plus-circle"></i>Agregar</button>
                            </template>

                        </div>

                    </div>
                    <div class="card-body">

                        <div class="shortcode-html">
                            <!-- Table Bordered -->

                            <div class="form-group row">

                                <div class="form-inline col-md-6 col-sm-12">
                                    <div class="form-group col">
                                        <label >Mostrar</label>
                                            <select v-model="pag_mostrar" class="form-control" v-on:change="getlistModelo(1,pag_mostrar)">
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        <label >registros por página</label>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-12">
                                    <div>
                                        <el-input @keyup.enter.native="getlistModelo(1,pag_mostrar)" placeholder="Texto a buscar" v-model="cBusqueda" class="input-with-select" clearable>
                                            <el-select v-model="cCriterio" slot="prepend" placeholder="Select">
                                            <el-option value="modelo" label="Nombre"></el-option>
                                            <el-option value="categoria" label="Categoria"></el-option>
                                            <el-option value="marca" label="Marca"></el-option>
                                            <el-option value="tipo_vehiculo" label="Tipo de Vehiculo"></el-option>
                                            </el-select> <i class="fas fa-search"></i>
                                            <el-button class="button-library-group" slot="append" icon="fas fa-search" @click.prevent="getlistModelo(1,pag_mostrar)"></el-button>
                                        </el-input>
                                    </div>
                                </div>

                            </div>

                            <div  class="table-responsive">

                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th><b>Nombre</b></th>
                                            <th><b>Categoria</b></th>
                                            <th><b>Marca</b></th>
                                            <th><b>Tipo de Vehiculo</b></th>
                                            <th><b>Estado</b></th>
                                            <th><b>Acciones</b></th>
                                        </tr>
                                    </thead>

                                    <tbody  v-if="listModelo.length">
                                        <tr v-for="(c, index) in listModelo" :key="index">

                                            <td v-text="c.nombre"></td>
                                            <td v-text="c.categoria"></td>
                                            <td v-text="c.marca"></td>
                                            <td v-text="c.tipo_vechiculo"></td>
                                            <td>
                                                <span class="u-label bg-success text-white" v-if="c.state=='A'" >Activo</span>
                                                <span class="u-label bg-danger text-white" v-else>Inactivo</span>
                                            </td>
                                            <td>
                                                <div class="btn-group mb-2 mr-2">
                                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-filter"></i> Acción</button>
                                                    <div class="dropdown-menu">
                                                        <template v-if="AsignarRolPermisosByUsuario.includes('modelo.editar')">
                                                            <button class="dropdown-item" @click="setObtenerModelo(c)"><i class="fa fa-edit text-info" ></i> Editar</button>
                                                        </template>
                                                        <template v-if="AsignarRolPermisosByUsuario.includes('modelo.desactivar')">
                                                            <button class="dropdown-item" v-if="c.state=='A'"  @click="setEstadoModelo(1,c.id)"><i class="fas fa-trash text-danger" ></i> Desactivar</button>
                                                        </template>
                                                        <template v-if="AsignarRolPermisosByUsuario.includes('modelo.activar')">
                                                            <button class="dropdown-item" v-if="c.state=='I'"  @click="setEstadoModelo(2,c.id)"><i class="fas fa-check text-success" ></i>  Activar</button>
                                                        </template>

                                                        <template v-if="AsignarRolPermisosByUsuario.includes('categoria.eliminar') && c.state=='I'">
                                                            <button class="dropdown-item"  @click="setDeleteModelo(c.id)"><i class="fa fa-trash text-danger" ></i> Eliminar</button>
                                                        </template>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td colspan="4" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                                <nav style="float: left;">  Mostrando la página <span v-text="pagination.current_page"></span> de <span v-text="pagination.last_page"></span></nav>
                                 <nav style="float: right;">


                                    <ul class="pagination singel-page flex-wrap" >
                                        <li class="page-item" v-if="pagination.current_page > 1">
                                            <a class="page-link" @click.prevent="cambiarPagina(pagination.current_page - 1)" href="#">Anterior</a>
                                        </li>
                                        <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(page)" v-text="page"></a>
                                        </li>
                                        <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(pagination.current_page + 1)">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>


                            <!-- End Table Bordered -->
                        </div>

                    </div>
                </div>
            </div>


        </div>

        <!--   Inicio modal Evidencia-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShow }" :style=" modalShow ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal">Registrar Evidencia</h5>
                        <button type="button" @click="abrirModal" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                       <form>
                           <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control"  v-model="vaCreModelo.nombre" placeholder="Ingresar Nombre del modelo del vehiculo">
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="categoria">Categoría</label>
                                        <select v-model="vaCreModelo.categoria"  class="custom-select" >
                                            <option value="0">Selecione una Categoría</option>
                                            <option v-for="cate in arrayCategoria" :key="cate.id" :value="cate.id" v-text="cate.nombre"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="categoria">Marca</label>
                                        <select v-model="vaCreModelo.marca"  class="custom-select" >
                                            <option value="0">Selecione una Marca</option>
                                            <option v-for="cate in arrayMarca" :key="cate.id" :value="cate.id" v-text="cate.nombre"></option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="categoria">Tipo de Vehiculo</label>
                                        <select v-model="vaCreModelo.tipo_vehiculo"  class="custom-select" >
                                            <option value="0">Selecione un Tipo de Vehiculo</option>
                                            <option v-for="cate in arrayTipoVehiculo" :key="cate.id" :value="cate.id" v-text="cate.nombre"></option>
                                        </select>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>

                     <div class="modal-footer">
                            <button type="button" v-if="actu_reg==0" class="btn btn-sm btn-primary" @click="setRegistrarModelo" v-text="nameButon">Guardar</button>
                            <button type="button" v-if="actu_reg==1" class="btn btn-sm btn-primary" @click="setActualizarModelo" v-text="nameButon">Actualizar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal Evidencia-------------------------------------------------------------->

    </div>

</div>
</template>

<script>

import {alertasM} from '../../../util.js';
export default {
    props: ['ruta'],
    data() {
        return {
            cCriterio: 'modelo',
            cBusqueda: '',
            listModelo: [],
            pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                },
            offset: 3,
            pag_mostrar: 5,//registros a mostrar por pagina tipo datable
            modalShow: false,

            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            vaCreModelo:{
                eId: 0,
                nombre: '',
                state: '',
                categoria: 0,
                marca: 0,
                tipo_vehiculo: 0,
            },
            tituloModal: '',
            nameButon: '',
            actu_reg: 0, //0 registrar - 1 actualizar
            AsignarRolPermisosByUsuario: JSON.parse(localStorage.getItem('listRolPermisosByUsuario')),
            money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
            },
            arrayMarca: [],
            arrayCategoria: [],
            arrayTipoVehiculo: []



        }
    },
    mixins: [alertasM],
    computed: {
            isActived: function() {
                return this.pagination.current_page;
            },
            //Calcula los elementos de la paginación
            pagesNumber: function() {
                if (!this.pagination.to) {
                    //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
                    return []; //Array vacio
                }

                var from = this.pagination.current_page - this.offset;
               // console.log("bengy: ", from);
                if (from < 1) {
                    //si la pagina actual es 0 entonces la igualamos  a uno
                    from = 1;
                }
                //la suma de la variable rom + el doble de la varialbe offset
                var to = from + this.offset * 2;
               // console.log("bengy2: ", from);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }

                var pagesArray = [];
                while (from <= to) {
                    /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                                from++; */
                    //Solucion
                    if (
                        (from >= this.pagination.current_page - 1) &
                        (from <= this.pagination.current_page + 3)
                    )
                        pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },
        },
    methods: {


        getlistModelo(page,pag_mostrar){

          var url = '/modelo';
          this.openCargando();//Activamos pantalla de carga de bloqueo
          axios.get(url,{
              params:{
                  'cCriterio': this.cCriterio,
                  'cBusqueda': this.cBusqueda,
                  'page' : page,
                  'pag_mostrar': pag_mostrar
              }
          })
          .then(res => {
                var respuesta = res.data;
                this.listModelo = respuesta.modelos.data;
                this.pagination = respuesta.pagination;
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })
          .catch(err => {
              if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                    }
                console.error(err);
          })

        },

        cambiarPagina(page) {
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.getlistModelo(page,me.pag_mostrar);
        },

        abrirModal() {
            this.modalShow = !this.modalShow;

            if(this.modalShow==true){

                this.tituloModal = "Registrar Modelo de Vehiculo";
                this.getSelectTipoCategoria();
                this.getSelectMarca();
                this.getSelectTipoVehiculo();
                this.actu_reg = 0;
                this.nameButon = "Guardar";

            }else{
               // this.aTipoDocumento = [];
                this.cleanVariables();
            }
        },

        cleanVariables(){
            this.vaCreModelo.nombre = "";
            this.vaCreModelo.categoria = 0;
            this.vaCreModelo.marca = 0;
            this.vaCreModelo.tipo_vehiculo = 0;
            this.vaCreModelo.eId = 0;
        },

        setRegistrarModelo(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/modelo/registrar';


            axios.post(url, {
                'nombre' : this.vaCreModelo.nombre,
                'categoria' : this.vaCreModelo.categoria,
                'marca' : this.vaCreModelo.marca,
                'tipo_vehiculo' : this.vaCreModelo.tipo_vehiculo,
            }).then(res => {

                this.cleanVariables();//Limpiamos el form
                this.getlistModelo(1,this.pag_mostrar);
                this.modalShow=false;

                if(res.data.status){

                    this.notify(" Modelo de Vehiculo registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }

            })
            .catch(err => {
                console.error(err);
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
              if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                }
            })
        },

        setActualizarModelo(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/modelo/actualizar';

            axios.put(url, {
                'id': this.vaCreModelo.eId,
                'nombre' : this.vaCreModelo.nombre,
                'categoria' : this.vaCreModelo.categoria,
                'marca' : this.vaCreModelo.marca,
                'tipo_vehiculo' : this.vaCreModelo.tipo_vehiculo,
            }).then(res => {


                this.cleanVariables();//Limpiamos el form
                //this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.getlistModelo(1,this.pag_mostrar);
                this.modalShow=false;
                if(res.data.status){

                    this.notify(" Modelo de Vehiculo actualizado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }

            })
            .catch(err => {
                console.error(err);
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                    }
            })
        },

        setObtenerModelo(data){
            //console.warn(data);
            this.tituloModal = "Actualizar Modelo del Vehiculo";
            this.nameButon = "Actualizar"
            this.getSelectTipoCategoria();
            this.getSelectMarca();
            this.getSelectTipoVehiculo();
            this.vaCreModelo.eId = data.id;
            this.vaCreModelo.nombre = data.nombre;
            this.vaCreModelo.categoria = data.idcategoria;
            this.vaCreModelo.marca = data.idmarca;
            this.vaCreModelo.tipo_vehiculo = data.idtipovehiculo;
            this.modalShow = true;
            this.actu_reg = 1;
        },
         //Actualizamos el estado de la categoria
        setEstadoModelo(op, id){
            this.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de ' + ((op == 1) ? 'desactivar' : 'activar') + ' el Modelo de Vehiculo?',
                //text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: ((op == 1) ? 'Si, desactivar' : 'Si, activar'),
                cancelButtonText: 'Cancelar',
                reverseButtons: true
                }).then((result) => {

                    if(result.value){

                        var url = '/modelo/estado';
                        this.openCargando();
                        axios.post(url,{
                            'id': id,
                            'estado' : (op == 1) ? 'I' : 'A'
                        })
                        .then(res => {

                            if(res.data.status){
                             this.notify(' Se ' + ((op == 1) ? 'desactivo' : 'activo') + ' el Modelo de Vehiculo',"","top","center",((op == 1) ? 'fas fa-check-circle' : 'fas fa-check-circle'),'success',' flipInX','flipOutX')
                            }
                            this.getlistModelo(1,this.pag_mostrar);
                        })
                        .catch(err => {
                            console.error(err);
                             this.openCargando(true);
                           if (err.response.status == 401) {
                                if (localStorage['authUser']) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                                }
                            }
                        })
                }
            })
        },

        setDeleteModelo(id){
            this.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de eliminar el Modelo?',
                //text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText:  'Si, eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
                }).then((result) => {

                    if(result.value){
                        var url = '/modelo/delete';
                        this.openCargando();
                        axios.post(url,{
                            'id': id,
                        })
                        .then(res => {


                             this.openCargando(true);

                            if(res.data.status){
                                this.notify(" Modelo Eliminado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                            }else{
                                this.notify(" La Modelo no se puede eliminar por que está en uso","","top","center","fas fa-exclamation-triangle","warning",' flipInX','flipOutX')
                            }
                            this.getlistModelo(1,this.pag_mostrar);
                        })
                        .catch(err => {
                             this.openCargando(true);
                            if (err.response.status == 401) {
                                if (localStorage['authUser']) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                                }
                            }
                            console.error(err);
                        })
                }
            })
        },

        getSelectTipoCategoria(){

            var url = '/categoria/getListarCategorias';

            axios.get(url)
            .then(res => {

                var respuesta = res.data;
                this.arrayCategoria = respuesta;

            })
            .catch(err => {
                console.error(err);
                if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                    }
            })
        },

        getSelectMarca(){

            var url = '/marca/getListarMarca';

            axios.get(url)
            .then(res => {

                var respuesta = res.data;
                this.arrayMarca = respuesta;

            })
            .catch(err => {
                console.error(err);
                if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                    }
            })
        },

        getSelectTipoVehiculo(){

            var url = '/marca/getListTipoVehiculo';

            axios.get(url)
            .then(res => {

                var respuesta = res.data;
                this.arrayTipoVehiculo = respuesta;

            })
            .catch(err => {
                console.error(err);
                if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                    }
            })
        },




    },
    mounted() {

           this.getlistModelo(1,this.pag_mostrar);


        },
}
</script>

<style>
</style>
